// Stockage du navigateur : seules quelques petites clés d'interface y vivent, tout le reste est sur le serveur.
// Les clés, en constantes, pour que personne n'en invente une hors de CLES_LOCALES_GARDEES.
export const CLES = {
    theme: 'edn_theme', connecte: 'edn_logged_in', planningCourant: 'edn_current_planning_id', undo: 'edn_undo_v1',
    sessionQcm: 'edn_qcm_session_v1', brouillonsRecall: 'edn_recall_drafts_v1', fileLots: 'edn_lots_file_v2',
    sousPartiesRestaurees: 'edn_subparts_restored_v1', presetsAutoplan: 'edn_autoplan_presets',
    adresseConnexion: 'edn_auth_email',
};
window.getPlanningTasksKey = function(id) { return 'edn_tasks_plan_' + id; };

// --- STOCKAGE DU NAVIGATEUR : PLUS DE COPIES DE SECOURS ------------------------------------------------------
// Le serveur est la seule source de vérité. Planning, sous-parties, partiels, journal d'apprentissage et
// préférences n'ont plus de copie dans le navigateur : elles saturaient son quota (≈ 5 Mo) et faisaient
// apparaître des avertissements. Ne restent en local que de petits états d'interface — mode jour/nuit, planning
// ouvert, séance de QCM ou d'active recall en cours, historique d'annulation, file des lots, configurations de
// l'Auto-Planifier. Les anciennes copies sont effacées une fois pour toutes au démarrage (purgerCopiesLocales).
window.CLES_LOCALES_GARDEES = /^(edn_theme|edn_logged_in|edn_current_planning_id|edn_undo_v1|edn_qcm_session_v1|edn_recall_drafts|edn_lots_file|edn_subparts_restored_v1|edn_autoplan_presets|edn_auth_email)/;
window.purgerCopiesLocales = function() {
    var aSupprimer = [];
    try {
        for (var i = 0; i < localStorage.length; i++) { var k = localStorage.key(i); if (k && k.indexOf('edn_') === 0 && !window.CLES_LOCALES_GARDEES.test(k)) aSupprimer.push(k); }
        aSupprimer.forEach(function(k) { localStorage.removeItem(k); });
    } catch (e) {}
};
// La liste des plannings vit en mémoire ; le serveur la renvoie à chaque ouverture (list_plannings).
window.loadPlanningsMetaLocal = function() {
    return (window.state.plannings && window.state.plannings.length) ? window.state.plannings : [{ id: 'default', name: 'Planning 1' }];
};
window.savePlanningsMetaLocal = function(list) { window.state.plannings = list; };

// Écriture locale : seuls les petits états d'interface passent (CLES_LOCALES_GARDEES) ; tout autre appel est ignoré
// sans bruit, la donnée étant déjà sur le serveur. Une écriture qui échoue (quota) n'interrompt JAMAIS ce qu'on
// faisait : on fait de la place (l'historique d'annulation, le plus gros et le plus sacrifiable) et on réessaie.
window.storageSet = function(cle, valeur) {
    if (!window.CLES_LOCALES_GARDEES.test(cle)) return true;
    try { localStorage.setItem(cle, valeur); return true; } catch (e) { /* plein */ }
    if (window.undoLibererPlace && window.undoLibererPlace()) {
        try { localStorage.setItem(cle, valeur); return true; } catch (e2) {}
    }
    return false;
};

// Exports : les mêmes fonctions que celles posées sur window (le code historique les lit encore là).
export const getPlanningTasksKey = window.getPlanningTasksKey;
export const CLES_LOCALES_GARDEES = window.CLES_LOCALES_GARDEES;
export const purgerCopiesLocales = window.purgerCopiesLocales;
export const loadPlanningsMetaLocal = window.loadPlanningsMetaLocal;
export const savePlanningsMetaLocal = window.savePlanningsMetaLocal;
export const storageSet = window.storageSet;
